// extracted by mini-css-extract-plugin
module.exports =  {"details":"details-EuHwi","video":"video-BIs3a","name":"name-vpn8u","info":"info-n1Tz1","icon":"icon-Di3yP","placeholder":"placeholder-Kigxt"};